import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import { getLocalizedPath } from '../i18n/localizedRoutes';
import { COLLECTION_SLUGS } from '../pages/collections';

const CollectionLinks = () => {
  const { t, locale } = useI18n();
  return <nav className="collection-links" aria-label={t('collections.title')}>
    {COLLECTION_SLUGS.map((slug) => <Link key={slug} to={getLocalizedPath(`/collections/${slug}`, locale)}>{t(`collections.${slug}.title`)}</Link>)}
  </nav>;
};
export default CollectionLinks;
